import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronLeft18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.4697 3.46967L11.5303 4.53033L7.06065 9L11.5303 13.4697L10.4697 14.5303L4.93933 9L10.4697 3.46967Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronLeft18.displayName = 'ChevronLeft18';
export default ChevronLeft18;
